import { CSSProperties, PropsWithChildren } from 'react';
import { SwipeableProps, useSwipeable } from 'react-swipeable';

interface IProps extends SwipeableProps, PropsWithChildren {
  style?: CSSProperties;
}

const Swipeable = ({ children, style, ...rest }: IProps) => {
  const handlers = useSwipeable(rest);

  return (
    <div {...handlers} style={style}>
      {children}
    </div>
  );
};

export default Swipeable;
